import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgSmartphone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 12,
	height: 20,
	viewBox: "0 0 12 20",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		opacity: .7,
		children: [/* @__PURE__ */ _jsx("path", { d: "M-4 0h20v20H-4z" }), /* @__PURE__ */ _jsx("path", {
			fill: "#000",
			fillRule: "nonzero",
			d: "M10.167.842L1.833.833C.917.833.167 1.583.167 2.5v15c0 .917.75 1.667 1.666 1.667h8.334c.916 0 1.666-.75 1.666-1.667v-15c0-.917-.75-1.658-1.666-1.658zm0 14.991H1.833V4.167h8.334v11.666z"
		})]
	})
});
export default SvgSmartphone;
